import api from 'api'
import { z } from 'zod'

export const createContestedHoursRequestSchema = z.object({
  associationId: z.number(),
  requestedStartedAt: z.string(),
  requestedFinishedAt: z.string(),
  requestedBreakDuration: z.coerce.number().nullable(),
  requestedReason: z.string(),
})

export type CreateContestedHoursRequest = z.infer<
  typeof createContestedHoursRequestSchema
>

export const createContestedHoursRequest = async (
  request: CreateContestedHoursRequest
): Promise<void> => {
  const parsedRequest = createContestedHoursRequestSchema.parse(request)

  await api.post('/admin/dayforce/create_contested_hours_request', {
    associationId: parsedRequest.associationId,
    requestedStartedAt: parsedRequest.requestedStartedAt,
    requestedFinishedAt: parsedRequest.requestedFinishedAt,
    requestedBreakDuration: parsedRequest.requestedBreakDuration,
    requestedReason: parsedRequest.requestedReason,
  })
}
